import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20style%20warm%20coral%20and%20amber%20gradient%20abstract%20background%20soft%20flowing%20lines%20decorative%20elegant%20curves%20illustration%20minimal%20artistic&width=1800&height=600&seq=hanman-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-accent-700/80"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-background-50 mb-4">
          准备好开启韩漫之旅了吗？
        </h2>
        <p className="text-base text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
          加入数百万读者，在韩漫网站享受无删减韩国漫画下拉式免费阅读体验。资源丰富、纯净无广告，随时随地畅读精彩韩漫！
        </p>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 bg-background-50 text-primary-700 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap"
        >
          <i className="ri-rocket-line"></i>
          立即免费阅读
        </Link>
      </div>
    </section>
  );
}